import React from "react";
import PropTypes from "prop-types";
import { SFStack, SFUseStyled } from "@sf-core";

const { styled } = SFUseStyled();

const SFStackStyled = styled(SFStack)(() => ({
  height: "100%",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
}));

const SFColumnRankRenderer = (props) => {
  return (
    <SFStackStyled direction="row">
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2728_10147)">
          <path
            d="M8.1252 11.875V4.89374L11.1752 7.94374C11.4189 8.18749 11.8189 8.18749 12.0627 7.94374C12.3064 7.69999 12.3064 7.30624 12.0627 7.06249L7.94394 2.94374C7.7002 2.69999 7.30645 2.69999 7.0627 2.94374L2.9377 7.05624C2.69395 7.29999 2.69395 7.69374 2.9377 7.93749C3.18145 8.18124 3.5752 8.18124 3.81895 7.93749L6.8752 4.89374V11.875C6.8752 12.2187 7.15645 12.5 7.5002 12.5C7.84395 12.5 8.1252 12.2187 8.1252 11.875Z"
            fill="#C4C4CD"
          />
        </g>
        <defs>
          <clipPath id="clip0_2728_10147">
            <rect width="15" height="15" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SFStackStyled>
  );
};

SFColumnRankRenderer.propTypes = {
  displayName: PropTypes.any,
  column: PropTypes.any,
  enableSorting: PropTypes.any,
  menuIcon: PropTypes.any,
  enableMenu: PropTypes.any,
  setSort: PropTypes.any,
  showColumnMenu: PropTypes.any,
  showFilter: PropTypes.any,
  getMainMenuItems: PropTypes.any,
};

export default SFColumnRankRenderer;
